import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="py-20 px-6" style={{ background: 'var(--bg-section)' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--sendhapy-teal)' }}>
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-xl text-gray-600">
            Miles de clientes satisfechos confían en SendHapy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="sendhapy-card">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star 
                    key={i} 
                    size={20} 
                    fill="var(--sendhapy-yellow)" 
                    style={{ color: 'var(--sendhapy-yellow)' }}
                  />
                ))}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed">
                "{testimonial.comment}"
              </p>
              <div className="pt-4 border-t border-gray-200">
                <p className="font-semibold" style={{ color: 'var(--sendhapy-teal)' }}>
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-500">{testimonial.location}</p>
                <p className="text-xs text-gray-400 mt-1">{testimonial.date}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Before/After Section */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-center mb-12" style={{ color: 'var(--sendhapy-teal)' }}>
            Antes y Después de SendHapy
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Before */}
            <div className="sendhapy-card bg-red-50 border-red-200">
              <h4 className="text-2xl font-bold mb-6 text-red-700">Antes ❌</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span className="text-gray-700">Sin información clara del estado</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span className="text-gray-700">Sin rastreo en tiempo real</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span className="text-gray-700">Entregas lentas e impredecibles</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span className="text-gray-700">Costos ocultos y sorpresas</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 font-bold">•</span>
                  <span className="text-gray-700">Soporte difícil de contactar</span>
                </li>
              </ul>
            </div>

            {/* After */}
            <div className="sendhapy-card bg-green-50 border-green-200">
              <h4 className="text-2xl font-bold mb-6 text-green-700">Después ✓</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span className="text-gray-700">Información clara en cada paso</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span className="text-gray-700">Rastreo en tiempo real 24/7</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span className="text-gray-700">Entregas rápidas y predecibles</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span className="text-gray-700">Precio justo sin sorpresas</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 font-bold">✓</span>
                  <span className="text-gray-700">Soporte por WhatsApp al instante</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
